import { useContext, useEffect } from 'react';
import { trackEventMatomo } from '../../../../helpers/matomo';
import { useTranslation } from 'react-i18next';
import { SubItemFormFilling } from '../../../Filling/Types';
import { NewWebFormContext } from '../../../../context/NewWebFormContext';
import AdditionalInfo from '../../Structure/AdditionalInfo';
import CheckIcon from '../../CheckIcon';
import { TextField, Typography } from '@material-ui/core';

type Props = {
  value: string | string[] | null;
  setValue: Function;
  subitem: SubItemFormFilling,
};

export class MaskHelper {
  static cpf(value: string) {
    return value
      .replace(/\D/g, "")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2")
  }

  static cnpj(value: string) {
    return value
      .replace(/\D/g, "")
      .replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1/$2")
      .replace(/(\d{4})(\d)/, "$1-$2")
  }

  static cpfCnpj(value: string) {
    let newValue = value?.length >= 15 ? MaskHelper.cnpj(value) : MaskHelper.cpf(value);
    return newValue.slice(0, 18);
  };

  static numberSubItemMask(value: string) {
    return value
      .replace(/[^-\d]/, '.')
      .replace(/^[^-\d]/, '')
      .replace(/(\d{1,})([^\d])/, '$1.')
      .replace(/(\d)(\W)(\W)/, '$1$2')
      .replace(/(\d)(\W)(\d{1,})(\W)/, '$1$2$3')
  };
}

export default function CpfCnpj({ subitem, value, setValue }: Props) {
  const { ForceUpdate } = useContext(NewWebFormContext);
  const { t } = useTranslation('translation')

  const checkItem = () => {
    const image = subitem.foto
    const text = subitem.comentario
    if (image || text) {
      if ([14, 18].includes(value?.length as number)) {
        return (<AdditionalInfo subItem={subitem} />)
      }
    }
  }

  useEffect(() => {
    if (subitem.ocorrencia) {
      setValue(subitem.ocorrencia)
    }
  }, [])

  useEffect(() => {
    if (subitem.padrao) {
      setValue(subitem.padrao);
      subitem.ocorrencia = subitem.padrao
    }
    if (CheckIcon(subitem, value) === 'ok') {
      subitem.checked = true
    }
  }, [])

  useEffect(() => {
    if (CheckIcon(subitem, value) === 'ok') {
      subitem.checked = true
    } else if (!value) {
      delete subitem.checked
    }
    ForceUpdate()
  }, [value])


  return (
    <>
      <Typography
        variant='h6'
        style={{
          wordBreak: 'break-all',
          marginBottom: '5px',
          width: '100%',
          textAlign: 'left'
        }}>
        {CheckIcon(subitem, value) === 'naoOk' && '*'}  {(subitem.id + 1)}
        - {subitem.nome}
      </Typography>
      <TextField
        style={{ backgroundColor: 'inherit' }}
        onClick={() => trackEventMatomo('seleciona documento', 'click', 'input', 'edita valor')}
        value={value as string}
        className={`${subitem.itemid}|${subitem.id}`}
        type="text"
        variant='outlined'
        onChange={(event) => {
          const newValue = MaskHelper.cpfCnpj(event.target.value);
          setValue(newValue);
          subitem.ocorrencia = newValue
          if (!newValue?.length) {
            delete subitem.ocorrencia
          }
        }}
      />
      {checkItem()}
    </>
  );
}
